/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
let finBase = window._env_.VUE_APP_FIN_CENTER_HOST

export const getInvoiceApplyTable = params => {
  return axios.post(`${finBase}/receipt-applications/lists`, params)
}
// export const getInvoiceApplyDetail = params => {
//   return axios.get(`${base}/receipt-apply/get_${params.id}`, {params})
// }
export const getInvoiceApplyDetail = params => {
  return axios.get(`${finBase}/receipt-applications/${params.id}`, {params})
}
// 重试同步金蝶
export const retrySyncKingDeeApi = params => {
  return axios.get(`${finBase}/receipt-applications/${params.id}/sync_kingdee`, {params})
}

// export const exportInvoiceApplyData = params => {
//   return axios.get(`${base}/exportInvoiceApplyData/${params.id}`, {params})
// }
// export const createInvoiceApplyData = params => {
//   return axios.post(`${base}/receipt-apply/create`, params)
// }
export const createInvoiceApplyData = params => {
  return axios.post(`${finBase}/receipt-applications/create`, params)
}
// export const updateInvoiceApplyData = params => {
//   return axios.post(`${base}/receipt-apply/edit_${params.id}`, params)
// }
export const updateInvoiceApplyData = params => {
  return axios.post(`${finBase}/receipt-applications/${params.id}/edit`, params)
}

export const changeInvoiceStatus = params => {
  return axios.post(`${base}/receipt-apply/update_status_${params.id}`, params)
}

// export const uploadReportFile = params => {
//   return axios.post(`${base}/receipt-apply/upload_report`, params)
// }
export const uploadReportFile = params => {
  return axios.post(`${finBase}/receipt-applications/detail/attached_files`, params)
}

// export const completeInvoiceApply = params => {
//   return axios.post(`${base}/receipt-apply/complete_receipt_${params.id}`, params)
// }

export const uploadAttachedFile = params => {
  return axios.post(`${base}/receipt-apply/upload_attached_file`, params)
}
export const uploadInvoiceApplyFile = params => {
  return axios.post(`${finBase}/receipt-applications/attached_files`, params)
}

// export const getInvoiceApplyFile = params => {
//   return axios.get(`${base}/oss_file_url`, {params})
// }

export const getInvoiceApplyFileUrl = params => {
  return `${base}/receipt-apply/attached_file?download=1&name=${params.name}&type=${params.type}&url=${params.url}`
}

// 下载详情pdf文件
export const downloadInvoiceDetailPdf = params => {
  return `${finBase}/receipt-applications/${params.id}/pdf`
}
export const batchDownloadInvoicePdfs = params => {
  return axios.post(`${finBase}/receipt-applications/batch_pdfs`, params)
}

export const getInvoiceProjectFinance = params => {
  return axios.get(`${base}/receipt-apply/project_finance_info_${params.id}`, {params})
}

// export const getInvoiceApproveTable = params => {
//   return axios.post(`${base}/receipt-apply/query_approve`, params)
// }
// 导出开票审批列表
// export const getExportApproveTable = params => {
//   return axios.post(`${base}/receipt-apply/export_approve_list`, params)
// }
export const getExportApproveTable = params => {
  return axios.post(`${finBase}/receipt-applications/lists/export`, params)
}

// 开票完成回款
export const completeReceivedPayment = params => {
  return axios.post(`${finBase}/received-payment-old/detail/${params.id}/force_completed`, params)
}
export const newCompleteReceivedPayment = params => {
  return axios.post(`${finBase}/receipt-applications/${params.id}/force_complete_collection`, params)
}
// 开票回款记录日志
// export const addReceivedPayment = params => {
//   return axios.post(`${base}/receipt-apply/receive_payment`, params)
// }
export const addReceivedPayment = params => {
  return axios.post(`${finBase}/received-payment-old/detail/${params.receipt_apply_detail_id}/collection`, params)
}

// 开票回款日志列表
// export const getReceivedPaymentLogTable = params => {
//   return axios.post(`${base}/receipt-apply/received_payment_log`, params)
// }
export const getReceivedPaymentLogTable = params => {
  return axios.post(`${finBase}/received-payment-old/detail/${params.id}/log/lists`, params)
}
// 开票回款查看
// export const getReceivedPaymentDetail = params => {
//   return axios.post(`${base}/receipt-apply/query_received_payment_detail`, params)
// }
export const getReceivedPaymentDetail = params => {
  return axios.post(`${finBase}/received-payment-old/${params.id}/detail/lists`, params)
}
// 开票回款导出
export const exportReceivedPayment = params => {
  return axios.post(`${finBase}/received-payment-old/lists/export`, params)
}
// 开票回款列表
// export const getReceivedPaymentTable = params => {
//   return axios.post(`${base}/receipt-apply/query_received_payment`, params)
// }
export const getReceivedPaymentTable = params => {
  return axios.post(`${finBase}/received-payment-old/lists`, params)
}

// export const uploadPaymentAttachedFile = params => {
//   return axios.post(`${base}/receipt-apply/upload_payment_attached_file`, params)
// }
export const uploadPaymentAttachedFile = params => {
  return axios.post(`${finBase}/received-payment-old/detail/upload_file`, params)
}

// 开票管理按搜索结果汇总
// export const getInvoiceAmountTotal = params => {
//   return axios.post(`${base}/receipt-apply/get_receipt_amount_total`, params)
// }
export const getInvoiceAmountTotal = params => {
  return axios.post(`${finBase}/receipt-applications/summary`, params)
}

export const getReceivedSummary = params => {
  return axios.post(`${finBase}/received-payment-old/summary`, params)
}

export const getInvoiceByIdsApi = params => {
  return axios.post(`${finBase}/receipt-applications/get_by_ids`, params)
}

export const extendPayDaysApi = params => {
  return axios.post(`${finBase}/receipt-applications/${params.id}/extend_pay_days`, params)
}

// export const getInvoiceApplyDefaultConfig = params => {
//   return axios.get(`${base}/receipt-apply/get_default_config`, {params})
// }

// export const deductItemApprovePass = params => {
//   return axios.post(`${base}/receipt-apply/pre_received/pass_approve_${params.id}`, params)
// }

// export const deductItemApproveReject = params => {
//   return axios.post(`${base}/receipt-apply/pre_received/reject_approve_${params.id}`, params)
// }

// export const deductItemApproveAbandon = params => {
//   return axios.post(`${base}/receipt-apply/pre_received/abandon_apply_${params.id}`, params)
// }

// export const updateReceiptDeductList = params => {
//   return axios.post(`${base}/receipt-apply/pre_received/edit_list_${params.id}`, params)
// }

// 导出预收款开票审批列表
// export const getExportPreReceivedApproveTable = params => {
//   return axios.post(`${base}/receipt-apply/pre_received/export_approve_list`, params)
// }
export const getExportPreReceivedApproveTable = params => {
  return axios.post(`${finBase}/receipt-applications/advances/lists/export`, params)
}
// 预收款开票按搜索结果汇总
export const getPrepareInvoiceAmountTotal = params => {
  return axios.post(`${finBase}/receipt-applications/advances/summary`, params)
}

// NEW API
export const buApprovePassReceiptApply = params => {
  return axios.post(`${finBase}/receipt-applications/${params.id}/bu/pass`, params)
}
export const buApproveRejectReceiptApply = params => {
  return axios.post(`${finBase}/receipt-applications/${params.id}/bu/reject`, params)
}
export const financeApprovePassReceiptApply = params => {
  return axios.post(`${finBase}/receipt-applications/${params.id}/finance/pass`, params)
}
export const financeApproveRejectReceiptApply = params => {
  return axios.post(`${finBase}/receipt-applications/${params.id}/finance/reject`, params)
}
export const getInvoiceApproveTable = params => {
  return axios.post(`${finBase}/receipt-applications/finance/lists`, params)
}
export const completeInvoiceApply = params => {
  return axios.post(`${finBase}/receipt-applications/${params.id}/complete_receipt`, params)
}
export const customerReceivedInvoice = params => {
  return axios.post(`${finBase}/receipt-applications/${params.id}/customer_received`, params)
}
export const cancelReceiptApply = params => {
  return axios.post(`${finBase}/receipt-applications/${params.id}/cancel_apply`, params)
}
export const returnInvoiceApply = params => {
  return axios.post(`${finBase}/receipt-applications/${params.id}/return_ticket/apply`, params)
}
export const rejectReturnInvoiceApply = params => {
  return axios.post(`${finBase}/receipt-applications/${params.id}/return_ticket/approve/reject`, params)
}
export const passReturnInvoiceApply = params => {
  return axios.post(`${finBase}/receipt-applications/${params.id}/return_ticket/approve/pass`, params)
}
export const createRedFlushTicket = params => {
  return axios.post(`${finBase}/receipt-applications/${params.id}/return_ticket/approve/red_flush`, params)
}
export const deductItemBuPass = params => {
  return axios.post(`${finBase}/receipt-applications/advances/deduct_items/${params.id}/bu/pass`, params)
}
export const deductItemBuReject = params => {
  return axios.post(`${finBase}/receipt-applications/advances/deduct_items/${params.id}/bu/reject`, params)
}
export const deductItemFinancePass = params => {
  return axios.post(`${finBase}/receipt-applications/advances/deduct_items/${params.id}/finance/pass`, params)
}
export const deductItemFinanceReject = params => {
  return axios.post(`${finBase}/receipt-applications/advances/deduct_items/${params.id}/finance/reject`, params)
}
export const deductItemApproveAbandon = params => {
  return axios.post(`${finBase}/receipt-applications/advances/deduct_items/${params.id}/abandon`, params)
}
export const updateReceiptDeductList = params => {
  return axios.post(`${finBase}/receipt-applications/advances/${params.id}/deduct_lists`, params)
}
export const getInvoiceApplyDefaultConfig = params => {
  // return axios.get(`${finBase}/receipt-applications/default_config`, {params})
  return axios.get(`${base}/setting/get_receipt_apply_config`, {params})
}

// 回款与开票详情进行关联
export const invoiceReceivedAssociation = params => {
  return axios.post(`${finBase}/received-payment/receipt_detail/${params.row_id}/received/${params.received_id}/assoc`, params)
}
// 删除回款与开票详情的关联关系
export const removeInvoiceCollectAssocApi = params => {
  return axios.post(`${finBase}/received-payment/assocId/${params.id}/remove_assoc`, params)
}

// 导出开票回款明细
export const receiptApplicationsUnCollection = params => {
  return axios.post(`${finBase}/receipt-applications/un_collection/export`, params)
}

// 导出开票未回款明细
export const receiptApplicationsCollection = params => {
  return axios.post(`${finBase}/receipt-applications/collection/export`, params)
}

// 获取百旺接口的xml数据参数
export const getBaiWangQueryXml = params => {
  return axios.post(`${finBase}/receipt_split/get_bw_xml`, params)
}
// 服务器解析 xml
export const handleBaiWangXml = params => {
  return axios.post(`${finBase}/receipt_split/handle_bw_xml`, params)
}
export const getBaiOpenTicketXml = params => {
  return axios.post(`${finBase}/receipt_split/get_ticket_xml`, params)
}
export const querySplitReceiptTable = params => {
  return axios.post(`${finBase}/receipt_split/lists`, params)
}
export const saveSplitTicketInfo = params => {
  return axios.post(`${finBase}/receipt_split/${params.id}/save_ticket`, params)
}
export const editSplitReceiptInfo = params => {
  return axios.post(`${finBase}/receipt_split/${params.id}/edit`, params)
}
export const setStatusToInvoicing = params => {
  return axios.post(`${finBase}/receipt_split/${params.id}/status_to_invoicing`, params)
}
export const setStatusToVoiding = params => {
  return axios.post(`${finBase}/receipt_split/${params.id}/status_to_voiding`, params)
}
export const manualSaveTicketSuccess = params => {
  return axios.post(`${finBase}/receipt_split/${params.id}/manual_save_ticket`, params)
}
export const manualVoidTicket = params => {
  return axios.post(`${finBase}/receipt_split/${params.id}/manual_void`, params)
}
export const backToPreviewStatus = params => {
  return axios.post(`${finBase}/receipt_split/${params.id}/back_status`, params)
}
export const returnSplitTicket = params => {
  return axios.post(`${finBase}/receipt_split/return_ticket`, params)
}

export const createReceiptSplitData = params => {
  return axios.post(`${finBase}/receipt_split/create`, params)
}

export const createRedFlushReceiptSplitData = params => {
  return axios.post(`${finBase}/receipt_split/create_red_flush`, params)
}



// WEBPACK FOOTER //
// ./src/views/invoice-apply/invoice-apply.api.js